import Header from '../components/header.js';
import WhiteThinLine from '../components/line.js';
import CheckIsMobile from '../components/mobile.js';

export default function Contact()
{
    let isMobile = CheckIsMobile();

    const H1Style = {
        textAlign: "center",
        display:"flex", 
        paddingTop: isMobile ? "1.5rem" : "2.5rem", 
        paddingBottom: isMobile ? "1.5rem" : "2.5rem", 
        justifyContent:"center", 
        alignContent:"center", 
        padding: "20px", 
        color:"cyan"
    }

    let ThickCyanLineStyle = {
        borderWidth: "1.5px", 
        borderColor: "cyan", 
        width: isMobile ? "60%" : "35%",    
        marginLeft: "auto", 
        marginRight: "auto"
    }

    let ParagraphStyle = {
        lineHeight: 1.8, 
        color: "white", 
        fontSize: isMobile ? "1.3rem" : "1.5rem", 
        paddingLeft: isMobile ? 50 : 75,
        paddingRight: isMobile ? 25 : 40, 
        font: "large", 
        alignItems: "center", 
        justifyContent: "center"
    }

    return (
        <div style={{background: "black"}}>
            <Header />

            <section style={H1Style}>
                <h1 style={{ alignContent: "center", fontSize : isMobile ? "2.0rem" : "2.5rem" }}>Contact Information</h1>
            </section>
            <hr style={ ThickCyanLineStyle } />

            <section style={ ParagraphStyle }>
                <p><br/>As an industry leader, Australian Machine Vision is committed to the successful deployment of vision system technologies.</p> <br/>
                <p>To learn more about these technologies and the benefits to your business, please contact us today.</p> <br/>
            </section>

            <WhiteThinLine />

            <section style={ ParagraphStyle }>
                <p><br/>Office: 9A Sir Laurence Drive Seaford 3198</p> <br/>
                <p>Phone: 0499 990 117 or 0418 535 729</p> <br/>
                <p>Email: amvsupport@amvco.com.au or krazga@amvco.com.au</p>
            </section>

            <br/> <hr style={{ borderWidth: "1.5px", borderColor: "white", width: "90%",          
                marginLeft: "auto", marginRight: "auto", marginTop: "1rem" }} /> 
            
            <br/> <br/> <br /> <br /> <br /> 
        </div>
    );
}

